<template>
  <div class="pa-6 d-flex flex-column row-gap-4 h-100" data-locator="details-content">
    <ChecklistPaneDetailsDescription :current-task="currentTask"
                                     :details="details"
                                     @data-unsaved="onDataUnsaved"
                                     @get-task-details="getPaneTaskDetails"
                                     @update-task="updateTask"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import { toast } from '@/common/utils/toast'
import ChecklistPaneDetailsDescription from '@/project/checklist/panes/ChecklistPaneDetailsDescription.vue'
import {
  EDIT_TASK,
  GET_PANE_TASK_DETAILS,
} from '@/store/modules/checklist/action_types'

const TRANSLATION_KEY_PREFIX = 'project.checklist.panes.ChecklistPaneDetails'

export default {
  name: 'ChecklistPaneDetails',
  components: { ChecklistPaneDetailsDescription },
  emits: ['data-unsaved', 'get-task-details', 'update-task'],
  computed: {
    ...mapGetters('room', ['roomMnemo']),
    ...mapState('checklist', ['checklistPane']),
    currentTask() {
      return this.checklistPane.tasks[0]
    },
  },
  data: () => ({
    details: null,
  }),
  watch: {
    currentTask: {
      immediate: true,
      handler (val) {
        if(val) {
          this.getPaneTaskDetails()
        }
      },
    },
  },
  beforeUnmount() {
    this.details = null
  },
  methods: {
    ...mapActions('checklist', [EDIT_TASK, GET_PANE_TASK_DETAILS]),
    async getPaneTaskDetails() {
      try {
        this.details = await this.GET_PANE_TASK_DETAILS({
          mnemo: this.roomMnemo,
          parent: this.checklistPane.parent,
          taskId: this.currentTask?.id,
        })
      } catch (e) {
        console.error(e)
        toast.error(this.$t(`${TRANSLATION_KEY_PREFIX}.getPaneTaskDetailsError`))
      }
    },
    onDataUnsaved (dataUnsaved) {
      this.$emit('data-unsaved', dataUnsaved)
    },
    async updateTask (data) {
      try {
        await this.EDIT_TASK({
          data,
          mnemo: this.roomMnemo,
          taskId: this.currentTask?.id,
        })
        
        if(this.currentTask) this.getPaneTaskDetails()

        toast.success(this.$t(`${TRANSLATION_KEY_PREFIX}.updateTaskSuccess`))
        
        this.$emit('data-unsaved', null)
      } catch (e) {
        console.error(e)
        toast.error(this.$t(`${TRANSLATION_KEY_PREFIX}.updateTaskError`))
      }
    },
  },
};
</script>
